const quickLinks = [
  { label: '核心玩法', href: '#features' },
  { label: '一起看专区', href: '#hot' },
  { label: '主题分类', href: '#categories' },
  { label: '漫友口碑', href: '#reviews' },
  { label: '常见问题', href: '#faq' },
];

const cateLinks = ['热血冒险', '甜宠恋爱', '悬疑烧脑', '搞笑日常', '玄幻修仙', '科幻机甲'];

export default function Footer() {
  const goTo = (href: string) => {
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="border-t border-background-300/50 bg-background-100/60">
      <div className="container-site grid gap-10 py-14 md:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-book-open-fill text-lg"></i>
            </span>
            <span className="font-heading text-2xl text-foreground-950">
              178<span className="text-primary-400">漫画网</span>
            </span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
            178漫画网一起看漫画专区，专注"同看、一起追、实时同步更新"，让每个漫友都能和志同道合的人一起看漫画、边看边聊，追更不孤单。
          </p>
          <div className="mt-5 flex gap-2">
            {['ri-wechat-line', 'ri-qq-line', 'ri-bilibili-line', 'ri-baidu-line'].map((ic) => (
              <a
                key={ic}
                href="#home"
                onClick={(e) => {
                  e.preventDefault();
                  goTo('#home');
                }}
                aria-label="社交平台入口"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300/60 text-foreground-500 transition-colors hover:border-primary-400 hover:text-primary-300 cursor-pointer"
              >
                <i className={ic}></i>
              </a>
            ))}
          </div>
        </div>

        <nav aria-label="快速导航">
          <h3 className="font-heading text-base text-foreground-950">快速导航</h3>
          <ul className="mt-4 space-y-2.5">
            {quickLinks.map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  onClick={(e) => {
                    e.preventDefault();
                    goTo(l.href);
                  }}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-300 cursor-pointer"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="主题分类">
          <h3 className="font-heading text-base text-foreground-950">主题分类</h3>
          <ul className="mt-4 flex flex-wrap gap-2.5">
            {cateLinks.map((c) => (
              <li key={c}>
                <a
                  href="#categories"
                  onClick={(e) => {
                    e.preventDefault();
                    goTo('#categories');
                  }}
                  className="inline-block rounded-md bg-background-200/60 px-3 py-1.5 text-xs text-foreground-600 transition-colors hover:bg-primary-500/20 hover:text-primary-300 cursor-pointer"
                >
                  {c}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="border-t border-background-300/40">
        <div className="container-site flex flex-col items-center justify-between gap-3 py-5 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} 178漫画网 · 一起看漫画，追更不孤单</p>
          <p>本站为漫画浏览与同看体验平台，不拥有任何作品版权，内容版权归原作者所有。</p>
        </div>
      </div>
    </footer>
  );
}